import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { Component } from 'react';
import Box from '../Box';
import HelperDrawer from '../HelperDrawer';
import Input from '../Input';
import Text from '../Text';
import StackView from '../StackView';
import { cloneChildren, generateId } from '../utils';

var Field = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Field, _Component);

  function Field() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "helperDrawerId", generateId('field-helper-drawer'));

    _defineProperty(_assertThisInitialized(_this), "fieldId", generateId('field'));

    return _this;
  }

  var _proto = Field.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        children = _this$props.children,
        compact = _this$props.compact,
        distribution = _this$props.distribution,
        feedbackText = _this$props.feedbackText,
        helpContent = _this$props.helpContent,
        icon = _this$props.icon,
        inline = _this$props.inline,
        innerRef = _this$props.innerRef,
        label = _this$props.label,
        labelBasis = _this$props.labelBasis,
        labelColor = _this$props.labelColor,
        labelGrow = _this$props.labelGrow,
        spacing = _this$props.spacing,
        state = _this$props.state,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["children", "compact", "distribution", "feedbackText", "helpContent", "icon", "inline", "innerRef", "label", "labelBasis", "labelColor", "labelGrow", "spacing", "state"]);

    return /*#__PURE__*/React.createElement(Box, _extends({
      innerRef: innerRef,
      width: "100%"
    }, restProps), /*#__PURE__*/React.createElement(StackView, {
      axis: inline ? 'horizontal' : 'vertical',
      wrap: true
    }, label && /*#__PURE__*/React.createElement(StackView, {
      axis: "horizontal",
      alignment: "center",
      grow: labelGrow,
      basis: labelBasis,
      marginRight: inline ? 2 : undefined
    }, icon, /*#__PURE__*/React.createElement(Input.InputLabel, {
      controls: this.fieldId,
      fontSize: compact ? 4 : 3,
      color: labelColor
    }, label), helpContent && /*#__PURE__*/React.createElement(HelperDrawer.Toggle, {
      drawerId: this.helperDrawerId,
      marginLeft: 0.25,
      marginRight: inline ? 1 : undefined
    })), helpContent && /*#__PURE__*/React.createElement(StackView, {
      axis: "horizontal",
      order: inline ? 1 : 0,
      width: "100%"
    }, /*#__PURE__*/React.createElement(HelperDrawer, {
      id: this.helperDrawerId,
      marginTop: 1,
      children: helpContent
    })), /*#__PURE__*/React.createElement(StackView, {
      axis: "horizontal",
      alignment: "center",
      distribution: distribution,
      order: inline ? 0 : 1,
      grow: 1,
      marginTop: inline || !label ? undefined : 1,
      spacing: spacing
    }, cloneChildren(children, function (child, _ref) {
      var firstChild = _ref.firstChild;
      return firstChild ? {
        id: _this2.fieldId,
        size: child.props.size || (compact ? 'sm' : 'md')
      } : {
        size: child.props.size || (compact ? 'sm' : 'md')
      };
    }))), feedbackText && /*#__PURE__*/React.createElement(Text, {
      marginTop: 1,
      color: state,
      align: inline ? 'right' : 'left'
    }, feedbackText));
  };

  return Field;
}(Component);

_defineProperty(Field, "defaultProps", {
  distribution: 'fill',
  spacing: 1
});

export default Field;